/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/Content/Images/Content/PatientImage/Content"
  
}) {
let resourceObjectMetaUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'url',
})
let imagesComparisonActionImageIdValueData = fromData.useDataValue({ viewPath,
context: 'images_comparison_action',
path: 'image_id',
})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let aggregateData = fromAggregate.equals(imagesComparisonActionImageIdValueData, patientImageIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="resource_object_meta.url"
 url={resourceObjectMetaUrlValueData}
 onClick={onClick}
 marginLeft={8}
 marginBottom={8}
 opacity={aggregateData ? 1 : 0.6}
 data="images_comparison_action.image_id"
 data="patient_image.id"
 aggregate="/Data/aggregate.js equals"
/>
{children}
</React.Fragment>)
}